import { Breadcrumb, Button, Card, Form, Select, Tabs } from "antd";
import { useCallback, useEffect, useState } from "react";
import { AiOutlineLeft } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router";
import AccountService from "../../../services/accounts.service";
import { amountFormat } from "../../../services/common.service";
import { ReactComponent as TitleIcon } from "../../../assests/images/accountBread.svg";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { accountListSelector } from "../../../store/selectors/app.selector";
import MiniStatement from "./casa/mini-statement";
import EStamentRequestCasa from "./casa/estatement-request";
import DetailedStatement from "./casa/detailed-statement";
import ShowAccountBalances from "./casa/showBalances";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";
import { setSelectedAccount } from "../../../store/actions/app.action";

export default function CASADetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const [accountDetails, setAccountDetails] = useState({});
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState("ACCOUNT_DETAILS");
  const [keyName, setKeyName] = useState("Account Summary");
  const accountList = useSelector(accountListSelector);
  const [selectedAccountNo, setSelectedAccountNo] = useState(
    location.state.accountNo
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (location.state) {
      console.log(location.state);
      setActiveKey(location.state.key);
      setAccountDetails(location.state);
      getAccountSummaryByAccNo(location.state);
      dispatch(setSelectedAccount(location.state));
    }
  }, []);

  const handleAccountNo = (value) => {
    setSelectedAccountNo(value);
    const accountDet = accountList.find((ele) => ele.accountNo === value);
    getAccountSummaryByAccNo(accountDet);
    dispatch(setSelectedAccount(accountDet));
  };

  const handleTabClick = (key) => {
    setActiveKey(key);
    if (key === "ACCOUNT_DETAILS") {
      setKeyName("Account Summary");
    }
    if (key === "MINI_STATEMENT") {
      setKeyName("Mini Statement");
    }
    if (key === "DETAILED_STATEMENT") {
      setKeyName("Detailed Statement");
    }
     if (key === "VIEW_BALANCES") {
       setKeyName("View Balances");
     }
    if (key === "E_STATEMENT") {
      setKeyName("E-Statement Request");
    }
  };

  const getAccountSummaryByAccNo = useCallback(async (details) => {
    try {
      const response = await AccountService.getAccountSummaryByAccNo({
        acctNo: details.accountNo,
        acctType: details.accountType,
      });
      if (response.status === 200) {
        setAccountDetails(response.data);
      }
    } catch (error) {}
  }, []);

  return (
    <>
      <Breadcrumb separator=">" className="hide-xs">
        {/* <Breadcrumb.Item>
          <span onClick={() => navigate("/dashboard")}>
            <HomeIcon height={14}/>
          </span>
        </Breadcrumb.Item> */}
        <Breadcrumb.Item>
          <span onClick={() => navigate("/accounts")}>
            {" "}
            {t("navigation.account", {
              defaultValue: "Accounts",
            })}
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span> {keyName}</span>
        </Breadcrumb.Item>
      </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card ">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0"> {keyName}</h3>
          </div>
          {(activeKey === "ACCOUNT_DETAILS" ||
            activeKey === "MINI_STATEMENT") && (
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end hide-xs">
              <label style={{ fontSize: "16px" }}>
                {t("common.account_no_lbl", {
                  defaultValue: "Account Number",
                })}{" "}
                :{" "}
              </label>
              <Select
                placeholder={t("common.account_no_lbl", {
                  defaultValue: "Account Number",
                })}
                bordered={true}
                optionLabelProp={"value"}
                size="small"
                value={selectedAccountNo}
                onChange={(value) => handleAccountNo(value)}
                style={{ width: "37%", textAlign: "justify" }}
              >
                {accountList.map((account, index) => (
                  <Select.Option key={index} value={account.accountNo}>
                    <span className="acc-short-name">
                      {account?.acctShortName}
                    </span>
                    <br />
                    <span style={{ fontSize: "12px" }}>
                      {account?.accountNo}
                    </span>
                    <br />
                    <span style={{ fontSize: "12px" }}>
                      {account?.branchName}
                    </span>
                  </Select.Option>
                ))}
              </Select>
            </div>
          )}
        </div>
      </Card>

      <Card className=" custom-card-style">
        <Tabs
          defaultActiveKey="1"
          type="line"
          onChange={setActiveKey}
          activeKey={activeKey}
          onTabClick={handleTabClick}
        >
          <Tabs.TabPane
            tab={t("pages.gepeg.account_details", {
              defaultValue: "Account Details",
            })}
            key="ACCOUNT_DETAILS"
          ></Tabs.TabPane>
          {/* <Tabs.TabPane
            tab={t("pages.gepeg.view_balances", {
              defaultValue: "View Balances",
            })}
            key="VIEW_BALANCES"
          ></Tabs.TabPane> */}
          <Tabs.TabPane
            tab={t("navigation.statement", {
              defaultValue: "Statement",
            })}
            key="MINI_STATEMENT"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("buttons.detailed_stmt_btn", {
              defaultValue: "Detailed Statement",
            })}
            key="DETAILED_STATEMENT"
          ></Tabs.TabPane>
          {/* <Tabs.TabPane
            tab={t("pages.my_accounts.casa.eStatement_Request", {
              defaultValue: "eStatement Request",
            })}
            key="E_STATEMENT"
          ></Tabs.TabPane> */}
        </Tabs>

        {activeKey === "ACCOUNT_DETAILS" && (
          <>
            <Card  className="mt-3 custom-card-style" >
              <div className="d-flex align-items-center">
                <span
                  style={{
                    display: "",
                    fontSize: "16px",
                    color: "#252C32",
                  }}
                  className=""
                >
                  {t("pages.my_accounts.casa.available_balance", {
                    defaultValue: "Available Balance",
                  })}
                </span>
                <div>
                  <h5
                    style={{
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontWeight: "600",
                    }}
                    className=""
                    align=""
                  >
                    {amountFormat(
                      accountDetails?.avlBalance,
                      accountDetails?.accountCcy
                    )}
                  </h5>
                </div>
              </div>
            </Card>

            <div className="account-details">
              <Card className="mt-3 application-card">
                {/* {(accountDetails?.acctType === "SB" ||
            accountDetails?.acctType === "CA") && ( */}
                <div className="row">
                  <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
                    <label>
                      {t("common.account_no_lbl", {
                        defaultValue: "Account Number",
                      })}
                    </label>
                    <span className="d-flex">
                      {accountDetails?.accountType}&nbsp;
                      {accountDetails?.accountNo}
                    </span>
                  </div>
                  <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
                    <label>
                      {" "}
                      {t("pages.my_accounts.common_my_accounts.account_name", {
                        defaultValue: "Account Name",
                      })}
                    </label>
                    <span>{accountDetails?.accountName || "-"}</span>
                  </div>
                  <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
                    <label>
                      {" "}
                      {t("common.account_class", {
                        defaultValue: "Account Class",
                      })}
                    </label>
                    <span>{accountDetails?.accountClass || "-"}</span>
                  </div>

                  <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
                    <label>
                      {" "}
                      {t("pages.sendMoney.payee.branch_name", {
                        defaultValue: "Branch Name",
                      })}
                    </label>
                    <span>{accountDetails?.branchName || "-"}</span>
                  </div>
                  <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
                    <label>
                      {t("pages.standing_instruction.branch_code", {
                        defaultValue: "Branch Code",
                      })}
                    </label>
                    <span>{accountDetails?.branchId || "-"}</span>
                  </div>

                  <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
                    <label>
                      {t("pages.standing_instruction.swift_code", {
                        defaultValue: "Swift Code",
                      })}
                    </label>
                    <span>{accountDetails?.swiftCode || "-"}</span>
                  </div>
                  {/*<div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>Effective Balance</label>
              <span>
                {amountFormat(
                  accountDetails?.effectiveBalance || "0",
                  accountDetails?.accountCcy
                )}
              </span>
            </div>

            <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>Ledger Balance</label>
              <span>
                {amountFormat(
                  accountDetails?.ledgerBalance || "0",
                  accountDetails?.accountCcy
                )}
              </span>
            </div>
            <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>Minimum Balance</label>
              {accountDetails?.minBalance === null && <span>-</span>}

              {accountDetails?.minBalance && (
                <span>
                  {accountDetails?.minBalance}
                  {amountFormat(
                    accountDetails?.fundsInClearing || "0",
                    accountDetails?.accountCcy
                  )}
                </span>
              )}
            </div>

            <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>Funds in Clearing</label>
              <span>
                {amountFormat(
                  accountDetails?.fundsInClearing || "0",
                  accountDetails?.accountCcy
                )}
              </span>
            </div>
            <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label> Drawable Amount</label>
              <span>
                {amountFormat(
                  accountDetails?.drawingPower || "0",
                  accountDetails?.accountCcy
                )}
              </span>
            </div>

            <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>Over Draft Balance</label>
              <span>
                {amountFormat(
                  accountDetails?.drawingPower || "0",
                  accountDetails?.accountCcy
                )}
              </span>
            </div>

            <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>{t("pages.my_accounts.deposits.lien_amount", {
                    defaultValue: "Lien Amount",
                  })}
                  </label>
              <span>
                {amountFormat(
                  accountDetails?.lienAmount || "0",
                  accountDetails?.accountCcy
                )}
              </span>
                </div>*/}
                  {/* <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>Reserved for I/W clg</label>
              <span>
              {amountFormat(accountDetails?.reserverdForIWClg || "0", accountDetails?.accountCcy)}
              </span>
            </div>
            
            <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>Against clg</label>
              <span>{accountDetails?.againstClearing || "-"}</span>
            </div> */}
                  {/* <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>TOD</label>
              <span>
              {amountFormat(accountDetails?.runningLimitCleanType || "0", accountDetails?.accountCcy)}
              </span>
            </div> */}
                  {/* {accNoDetails !== undefined &&
                accNoDetails.jointHolderNames !== undefined &&
                accNoDetails.jointHolderNames.map((v) => {
                  return <>{renderDetail("Joint holders :", v)}</>;
                })} */}
                  {/* <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
                <label>Nominee Registered</label>
                <span>
                  {accountDetails?.nomineeRegistered === true
                    ? t("buttons.yes_btn", {
              defaultValue: "Yes",
            })
                    : t("buttons.no_btn", {
                        defaultValue: "No",
                      }) || "-"}
                </span>
              </div> */}
                  <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
                    <label>
                      {t("pages.standing_instruction.is_dormant", {
                        defaultValue: "Is Dormant",
                      })}
                    </label>
                    <span>
                      {accountDetails?.dormant === true
                        ? t("buttons.yes_btn", {
                            defaultValue: "Yes",
                          })
                        : t("buttons.no_btn", {
                            defaultValue: "No",
                          }) || "-"}
                    </span>
                  </div>
                  {/*<div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>Is Frozen</label>
              <span>
                {accountDetails?.frozen === true ? "Yes" : "No" || "-"}
              </span>
            </div>
            <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>Credit Allowed</label>
              <span>
                {accountDetails?.noCredit === true ? "NO" : "Yes" || "-"}
              </span>
            </div>
            <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>Debit Allowed</label>
              <span>
                {accountDetails?.noDebit === true ? "No" : "Yes" || "-"}
              </span>
            </div>*/}
                  {/* {accountDetails?.nomineeDetails?.length > 0 && (
              <>
                <div className="col-3">
                  <label> {t("pages.my_accounts.deposits.nominee_name", {
                            defaultValue: "Nominee name",
                          })}</label>
                  <span>
                    {(accountDetails?.nomineeDetails &&
                      accountDetails?.nomineeDetails?.length > 0 &&
                      accountDetails?.nomineeDetails[0].nomineeName) ||
                      "-"}
                  </span>
                </div>
                <div className="col-3">
                  <label>{t("pages.my_accounts.deposits.nominee_relation", {
                            defaultValue: "Nominee Relation",
                          })}</label>
                  <span>
                    {(accountDetails?.nomineeDetails &&
                      accountDetails?.nomineeDetails?.length > 0 &&
                      accountDetails?.nomineeDetails[0].nomineeRelation) ||
                      "-"}
                  </span>
                </div>
              </>
            )} */}
                  {/* {accNoDetails !== undefined &&
              accNoDetails.nomineeDetails !== undefined &&
              accNoDetails.nomineeDetails.map((v) => {
                return (
                  <>
                    {renderDetail("Nominee name :", v.nomineeName)}
                    {renderDetail("Nominee relation :", v.nomineeRelation)}
                  </>
                );
              })} */}
                  {/* <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>IFSC</label>
              {accountDetails?.ifsc !== null &&
              accountDetails?.ifsc?.length > 0 ? (
                <span>
                  {accountDetails?.ifsc.slice(0, 4)}{" "}
                  {accountDetails?.ifsc.slice(4, accountDetails?.ifsc?.length)}{" "}
                </span>
              ) : (
                "-"
              )}
            </div> */}
                  {/* <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
              <label>Tiss ID</label>
              <span>{accountDetails?.tissId || "-"}</span>
            </div> */}
                  <div className="col-12 col-sm-6 col-md-12 col-lg-3 mb-3">
                    <label>
                      {t("common.status", { defaultValue: "Status" })}
                    </label>
                    <span>{accountDetails?.accStatus || "-"}</span>
                  </div>
                </div>
                {/* // )} */}
              </Card>
            </div>
          </>
        )}
        {activeKey === "MINI_STATEMENT" && <MiniStatement />}
        {/* {activeKey === "VIEW_BALANCES" && <ShowAccountBalances />} */}
        {activeKey === "DETAILED_STATEMENT" && <DetailedStatement />}
        {activeKey === "E_STATEMENT" && <EStamentRequestCasa />}
      </Card>
    </>
  );
}
